import { AppData } from '@/types';
import { demoData } from '@/data/demo';

const STORAGE_PREFIX = 'family_tree_';

export function getStorageKey(key: string): string {
  return `${STORAGE_PREFIX}${key}`;
}

export function getData<T>(key: string, defaultValue: T): T {
  try {
    const item = localStorage.getItem(getStorageKey(key));
    return item ? JSON.parse(item) : defaultValue;
  } catch {
    return defaultValue;
  }
}

export function setData<T>(key: string, value: T): void {
  try {
    localStorage.setItem(getStorageKey(key), JSON.stringify(value));
  } catch (error) {
    console.error(`Error saving to localStorage:`, error);
  }
}

export function getAppData(): AppData {
  return getData('app_data', demoData);
}

export function initializeData(): void {
  const appDataKey = getStorageKey('app_data');
  const usersKey = getStorageKey('users');

  // Initialize app data if not exists
  if (!localStorage.getItem(appDataKey)) {
    setData('app_data', demoData);
    window.location.reload();
  }

  // Initialize demo admin if not exists
  const users = getData('users', []);
  if (users.length === 0) {
    setData('users', [{
      id: 'admin1',
      username: 'مدير النظام',
      phoneNumber: '0556213992',
      role: 'admin',
      permissions: ['*']
    },
    {
      id: 'admin2',
      username: 'مدير النظام',
      phoneNumber: '0545454344',
      role: 'admin',
      permissions: ['*']
    }
    ,
    {
      id: 'admin3',
      username: 'مدير النظام',
      phoneNumber: '0565855516',
      role: 'admin',
      permissions: ['*']
    },
    {
      id: 'admin4',
      username: 'مدير النظام',
      phoneNumber: '0505253468',
      role: 'admin',
      permissions: ['*']
    },
    {
      id: 'admin4',
      username: 'مدير النظام',
      phoneNumber: '0591444148',
      role: 'admin',
      permissions: ['*']
    },
  ]);

    window.location.reload();
  }

  
}